import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PortalEvent } from "src/app/classes/calendar";
import { Answer, Question } from "src/app/classes/dynamic-form";
import { DynamicFormService } from "src/app/services/dynamic-form.service";


@Component( {
	selector: "dynamic-form-readonly",
	templateUrl: "./dynamic-form-readonly.component.html",
	styleUrls: [ './dynamic-form-readonly.component.scss' ]
})
export class DynamicFormReadOnlyComponent {


	_event = new PortalEvent();
	@Input() set event( value: PortalEvent ) {
		if( value && value.id ) {
			this._event = value;
			this.load();
		}
	}

	_answer = new Answer();
	@Input() set answer( value: Answer ) {
		if( value && value.vbId ) {
			this._answer = value;
			this.load();
		}
	}

	formGroup = new FormGroup( {} );
	questionTree: Question[] = [];

	bLoaded = false;


	constructor(
		private dynamicFormService: DynamicFormService,
	) {}


	load() {

		if( !this._event.id ) return;
		if( !this._answer.vbId ) return;

		this.dynamicFormService.initialiseForm( this.formGroup, this._event.categoryId, this._answer.vbAntwort ).subscribe( questionTree => {
			
			this.questionTree = questionTree;

			setTimeout( () => {
				this.formGroup.disable( { emitEvent: false });
				this.bLoaded = true;
			},50);

		});

	}


}
